<ng-container>
  <section>
    <div
      class="section-header d-flex align-items-center justify-content-between"
    >
      <span class="text-muted" i18n="UserMenu@@userMenuUserContactsTitle"
        >Available business contacts</span
      >
      @if (!isLoading && showShowAllButton) {
      <button
        i18n="contacts@@contactsShowAll"
        (click)="showAllClicked()"
        type="button"
        class="btn btn-link text-decoration-none p-0 btn-sm"
      >
        Show all
      </button>
      }
    </div>
    <div class="content">
      <ng-content select=".pre-contact-list"></ng-content>
      @if (!isLoading && contacts && contacts.length > 0) { @if
      (contactsListTemplateRef) {
      <ng-container
        [ngTemplateOutlet]="contactsListTemplateRef"
        [ngTemplateOutletContext]="{ $implicit: contacts }"
      >
      </ng-container>
      } @else {
      <atx-contact-list
        [contacts]="contacts"
        [hyperlinkEmail]="hyperlinkEmail"
      ></atx-contact-list>
      } } @else {
      <p class="mb-0 text-muted text-center">
        @if (isLoading) {
        <span i18n="Contacts@@contactsIsLoading"> Loading... </span>
        } @if (!isLoading) {
        <span i18n="Contacts@@contactsEmptyContactListMessage">
          You do not have business contacts
        </span>
        }
      </p>
      }
    </div>
    <ng-content select=".post-content"></ng-content>
  </section>
</ng-container>
